<p-card>
  <div>
    <h2>Material Icons</h2>
    <p class="p1">
      Use the <a href="https://fonts.google.com/icons?icon.style=Rounded">Material Icons Page (Rounded Set)</a> to see
      available icons.
    </p>
    <p>
      We have support for only the material rounded set (mi-round). To support other sets, add their otf font files in
      assets/fonts and declare their font-face in styles/_fonts.scss
    </p>
    <p>
      To create an icon use the class for the material icon set, then the class for the icon, e.g., "mi-round
      mi-add-circle-outline"
    </p>
  </div>
  <div>
    <h2>Divisional Icons</h2>
    <p class="p1">
      Use the
      <a href="https://www.figma.com/file/3jzjU89rOdkryNhjS5x4WI/CCS---UI-Toolkit?node-id=1005%3A40030">Figma File</a>
      to see available divisional icons.
    </p>
    <p>
      To add an icon, add it to assets/icons/divisional-icons. Use svg version and similar naming convention. Sample
      icon below in 3 colors:
    </p>
    <img src="./assets/icons/divisional-icons/alarm-clock-blue.svg" width="182px" />
    <img src="./assets/icons/divisional-icons/alarm-clock-purple.svg" width="182px" />
    <img src="./assets/icons/divisional-icons/alarm-clock-teal.svg" width="182px" />
  </div>
</p-card>
